import main from "./main";
import customerManagement from "./customerManagement";
import payment from "./payment";

import { combineReducers } from "redux";

const reducers = () => combineReducers({ main, customerManagement, payment });

export default reducers;
